import React from "react";
import {
  Nav,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  Container,
  Collapse,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// Import Logo
import logopositive from "../../assets/images/logo-positive.png";
import logolight from "../../assets/images/logo-light.png";
import logodark from "../../assets/images/logo-dark.png";
import globalGateway from "../../assets/images/logos-importantes/Global.jpg";
import alInvestVerde from "../../assets/images/logos-importantes/Al-Invest-verde.jpg";
import unionEuropea from "../../assets/images/logos-importantes/Uniion_europea.png";
import "./NavBar.css"; 


//import icon
import FeatherIcon from "feather-icons-react";

import { useLocation } from "react-router-dom";


import useNavbarScroll from '../../hooks/useNavbarScroll';
import GlobalSearch from '../GlobalSearch';
import LanguageSwitcher from './LanguageSwitcher';

// Custom hook to detect mobile/tablet (width < 992px)
function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(() => window.innerWidth < 992);
  React.useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 992);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return isMobile;
}



const NavbarPage = ({ navItems }) => {
  const [isOpenMenu, setIsOpenMenu] = React.useState(false);
  const { navClass, imglight } = useNavbarScroll();
  const location = useLocation();
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  const toggle = () => setIsOpenMenu(!isOpenMenu);

  return (
    <React.Fragment>

          {/* Top bar con logos financiadores */}
    <div className="top-logos-bar">
      <div className="top-logos-inner">
        <img className="top-logo" src={globalGateway} alt="Global Gateway" />
        <img className="top-logo" src={alInvestVerde} alt="AL-INVEST Verde" />
        <img className="top-logo top-logo-ue" src={unionEuropea} alt="Financiado por la Unión Europea" />
      </div>
    </div>

      <nav
        expand="lg"
        fixed="top"
        className={"navbar navbar-expand-lg fixed-top navbar-custom " + navClass}
        id="navbar"
        style={{ top: "64px" }}  //
      >
        <Container fluid style={{ paddingLeft: '2rem', paddingRight: '2rem' }}>
          <NavbarBrand className="logo" style={{ marginRight: 'auto' }}>
            <Link to="/">
              {isMobile ? (
                <img src={logodark} alt="Mundo Verde" height="56" />
              ) : (
                imglight ? (
                  <img src={logolight} alt="Mundo Verde" height="80" />
                ) : (
                  <img src={logopositive} alt="Mundo Verde" height="80" />
                )
              )}
            </Link>
          </NavbarBrand>
          <NavbarToggler onClick={toggle}>
            <i>
              <FeatherIcon icon="menu" />
            </i>
          </NavbarToggler>
          <Collapse
            id="navbarCollapse"
            isOpen={isOpenMenu}
            className="navbar-collapse"
          >
            <Nav navbar className="ms-auto d-flex align-items-center" id="mySidenav" style={{ gap: '0.5rem' }}>
              <div className="nav-search-wrap" style={{ minWidth: 220, maxWidth: 340, marginRight: '1.2rem' }}>
                <GlobalSearch />
              </div>
              {navItems.map((item, key) => (
                <NavItem
                  key={key}
                  className={
                    (item.link && item.link.startsWith('/#') && location.pathname === "/") ||
                    (item.link && !item.link.startsWith('/#') && item.link === location.pathname) ||
                    (item.navheading === "Inicio" && location.pathname === "/")
                      ? "active"
                      : ""
                  }
                  style={{ margin: '0 0.2rem' }}
                >
                  {item.link ? (
                    item.link.startsWith('/#') ? (
                      <a
                        href={item.link}
                        className="nav-link"
                        style={{
                          textDecoration: 'none',
                          padding: '0.6rem 1rem',
                          fontWeight: '500',
                          fontSize: '1.1rem',
                          transition: 'all 0.3s ease',
                          borderRadius: '6px',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {item.navheadingKey ? t(item.navheadingKey) : item.navheading}
                      </a>
                    ) : (
                      <Link
                        to={item.link}
                        className={`nav-link ${(item.link === location.pathname) ? "active" : ""}`}
                        style={{
                          textDecoration: 'none',
                          padding: '0.6rem 1rem',
                          fontWeight: (item.link === location.pathname) ? '600' : '500',
                          fontSize: '1.1rem',
                          transition: 'all 0.3s ease',
                          borderRadius: '6px',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {item.navheadingKey ? t(item.navheadingKey) : item.navheading}
                      </Link>
                    )
                  ) : (
                    <a
                      href={`#${item.idnm}`}
                      className="nav-link"
                      style={{
                        textDecoration: 'none',
                        padding: '0.6rem 1rem',
                        fontWeight: '500',
                        fontSize: '1.1rem',
                        transition: 'all 0.3s ease',
                        borderRadius: '6px',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {item.navheadingKey ? t(item.navheadingKey) : item.navheading}
                    </a>
                  )}
                </NavItem>
              ))}
              <NavItem style={{ marginLeft: '0.5rem' }}>
                <LanguageSwitcher />
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </nav>
    </React.Fragment>
  );
};

export default NavbarPage;
